module.exports = __webpack_public_path__ + "img/217-united nations.2bd8b581.svg";